import './LiveHeader.sass';

import React, { FC, useCallback, useEffect, useMemo } from 'react';
import { Currency, UnitName, UnitPhoto } from '$shared/components';
import { LiveHeaderProps } from './LiveHeader.interface';
import { IcClose28, IcViews24 } from '$assets';
import { goTo } from '$navigation/helper';
import { RESOLVE } from '$shared/constants/pages';
import { classNames as cn } from '$utils';
import { useTranslator } from '$hooks';
import { LiveCounterButton } from '$core/Live/LiveCounterButton/LiveCounterButton';
import { CurrencyEnum } from '$store/models';
import { useStopwatch, useTime } from 'react-timer-hook';

export const LiveHeader: FC<LiveHeaderProps> = ({
  user,
  viewers,
  onClose,
  userLink,
  tips,
  createdAt,
  showControls = false,
  liveLabel,
  onTipsClick,
  onViewerClick,
  onTimeClick,
}) => {
  const handleUserClick = useCallback(() => {
    if (userLink) {
      window.open(`/${user.domain || `id${user.id}`}`, '_blank');
    }
  }, [userLink]);

  const sw = useStopwatch({
    autoStart: true,
  });

  useEffect(() => {
    if (createdAt) {
      sw.reset(new Date(Date.now() + (Date.now() - (createdAt || 0) * 1000)));
      sw.start();
    }
  }, [createdAt]);

  const time = useMemo(
    () =>
      [sw.hours || false, sw.minutes, sw.seconds]
        .filter((v) => typeof v === 'number')
        .map((v) => v.toString().padStart(2, '0'))
        .join(':'),
    [sw],
  );

  return (
    <div className="LiveHeader">
      <div
        className={cn('LiveHeader__user', {
          active: userLink,
        })}
        onClick={handleUserClick}
      >
        <UnitPhoto
          routeName={null}
          size="extra-small"
          onlineIndicator={false}
          unit={user}
        />
        <div className="LiveHeader__name">
          <UnitName unit={user} />
        </div>
      </div>
      {showControls && (
        <div className="LiveHeader__controls">
          {viewers !== undefined && (
            <LiveCounterButton onClick={onViewerClick} icon={<IcViews24 />}>
              {viewers}
            </LiveCounterButton>
          )}
          {tips !== undefined && (
            <LiveCounterButton onClick={onTipsClick}>
              <Currency amount={tips} currency={CurrencyEnum.EUR} />
            </LiveCounterButton>
          )}
          {createdAt && (
            <LiveCounterButton onClick={onTimeClick} minWidth={40} style="primary">
              {liveLabel ? 'LIVE' : time}
            </LiveCounterButton>
          )}
        </div>
      )}
      {onClose && (
        <div className="LiveHeader__close" onClick={onClose}>
          <IcClose28 />
        </div>
      )}
    </div>
  );
};
